module.exports = __webpack_public_path__ + "img/logo_half.2767e13b.svg";